/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusBenutzerListResponseDto } from '../../models/lexplus-benutzer-list-response-dto';
import { LexplusComplianceAccessState } from '../../models/lexplus-compliance-access-state';

export interface BenutzerverwaltungControllerFindAllPaginatedV1$Params {
  complianceAccessState?: LexplusComplianceAccessState;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by kundeID query param.
 *
 * **Format:** filter.kundeID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.kundeID=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.kundeID'?: Array<string>;

/**
 * Filter by istNeosysAdmin query param.
 *
 * **Format:** filter.istNeosysAdmin={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.istNeosysAdmin=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.istNeosysAdmin'?: Array<string>;

/**
 * Filter by lockoutEndDateUtc query param.
 *
 * **Format:** filter.lockoutEndDateUtc={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.lockoutEndDateUtc=$null:John Doe
 *
 * **Available Operations**
 * - $null
 *
 * - $and
 *
 * - $or
 */
  'filter.lockoutEndDateUtc'?: Array<string>;

/**
 * Filter by istKundeAdmin query param.
 *
 * **Format:** filter.istKundeAdmin={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.istKundeAdmin=$eq:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $and
 *
 * - $or
 */
  'filter.istKundeAdmin'?: Array<string>;

/**
 * Filter by applicationUserShortcut.shortcut_ShortcutID query param.
 *
 * **Format:** filter.applicationUserShortcut.shortcut_ShortcutID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.applicationUserShortcut.shortcut_ShortcutID=$eq:John Doe&filter.applicationUserShortcut.shortcut_ShortcutID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.applicationUserShortcut.shortcut_ShortcutID'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=nachname:DESC&sortBy=vorname:DESC
 *
 *
 * **Default Value:** nachname:ASC
 *
 * **Available Fields**
 * - nachname
 *
 * - vorname
 *
 * - email
 *
 * - newsletterAktiv
 *
 * - spracheSprache.lokalisierung
 */
  sortBy?: Array<'nachname:ASC' | 'nachname:DESC' | 'vorname:ASC' | 'vorname:DESC' | 'email:ASC' | 'email:DESC' | 'newsletterAktiv:ASC' | 'newsletterAktiv:DESC' | 'spracheSprache.lokalisierung:ASC' | 'spracheSprache.lokalisierung:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** vorname,nachname,email
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 * - vorname
 *
 * - nachname
 *
 * - email
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** id,vorname,nachname,email,spracheID
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function benutzerverwaltungControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: BenutzerverwaltungControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusBenutzerListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, benutzerverwaltungControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('complianceAccessState', params.complianceAccessState, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.kundeID', params['filter.kundeID'], {});
    rb.query('filter.istNeosysAdmin', params['filter.istNeosysAdmin'], {});
    rb.query('filter.lockoutEndDateUtc', params['filter.lockoutEndDateUtc'], {});
    rb.query('filter.istKundeAdmin', params['filter.istKundeAdmin'], {});
    rb.query('filter.applicationUserShortcut.shortcut_ShortcutID', params['filter.applicationUserShortcut.shortcut_ShortcutID'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusBenutzerListResponseDto>;
    })
  );
}

benutzerverwaltungControllerFindAllPaginatedV1.PATH = '/v1/benutzerverwaltung';
